import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { jwtGuard } from './_guards/jwt.guard';
import { proveedorGuard } from './_guards/proveedor.guard';
import { administracionGuard } from './_guards/administracion.guard';

const routes: Routes = [
  {
    path: 'admin',
    loadChildren: () =>
      import('./admin/admin.module').then((m) => m.AdminModule),
    canActivate: [jwtGuard, administracionGuard],
  },
  {
    path: 'login',
    loadChildren: () =>
      import('./login/login.module').then((m) => m.LoginModule),
  },
  {
    path: 'restablecer-contrasena',
    loadChildren: () =>
      import(
        './restablecer-contrasena-page/restablecer-constrasena-page.module'
      ).then((m) => m.RestablecerConstrasenaPageModule),
  },
  // Textos legales: fuera de tienda y admin para que sean accesibles sin sesión.
  {
    path: 'politica-privacidad',
    loadChildren: () =>
      import(
        './textos-legales/politica-privacidad/politica-privacidad.module'
      ).then((m) => m.PoliticaPrivacidadPageModule),
  },
  {
    path: 'aviso-legal',
    loadChildren: () =>
      import('./textos-legales/aviso-legal/aviso-legal.module').then(
        (m) => m.AvisoLegalPageModule,
      ),
  },
  {
    path: 'politica-cookies',
    loadChildren: () =>
      import(
        './textos-legales/politica-cookies/politica-cookies.module'
      ).then((m) => m.PoliticaCookiesPageModule),
  },
  {
    path: '',
    loadChildren: () =>
      import('./tienda/tienda.module').then((m) => m.TiendaModule),
    canActivate: [jwtGuard, proveedorGuard],
  },
  { path: '**', redirectTo: '', pathMatch: 'full' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
      onSameUrlNavigation: 'reload',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
